import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=1f066b0e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=1f066b0e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f066b0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f066b0e')) {
      api.createRecord('1f066b0e', component.options)
    } else {
      api.reload('1f066b0e', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=1f066b0e&scoped=true", function () {
      api.rerender('1f066b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/purchase/pending-receive/views/Main.vue"
export default component.exports